<!-- FILE GENERATED BY packages/components/design-tokens/build-scripts/generate-icons.js DO NOT CHANGE -->

<svg
    xmlns="http://www.w3.org/2000/svg"
    fill="none"
    data-token-name="IconBackgroundBlur_16"
    viewBox="0 0 16 16"
    aria-hidden="true"
>
    <g clip-path="url(#IconBackgroundBlur_16__a)">
        <g clip-path="url(#IconBackgroundBlur_16__b)">
            <path
                fill="currentColor"
                d="M8 9.038a2.78 2.78 0 0 0 2.778-2.778A2.78 2.78 0 0 0 8 3.483 2.78 2.78 0 0 0 5.222 6.26 2.78 2.78 0 0 0 8 9.038"
            />
        </g>
        <path
            fill="currentColor"
            fill-rule="evenodd"
            d="m15.417-8.08 1.238 1.238-9.498 9.498a3.69 3.69 0 0 0-2.77 2.77L-6.2 16.013l-1.238-1.237zM2.766 9.877 4.71 7.932A3.7 3.7 0 0 0 5.866 9.25l-.001.002c-1.198.113-2.226.325-3.1.624m-3.952 3.951-6.203 6.204 1.237 1.237 5.46-5.46a2.04 2.04 0 0 1-.54-1.74q.022-.124.046-.241m3.447 2.738.797.797.797-.797zm4.422 0L5.4 17.848l1.237 1.238 2.521-2.521zM15 10.723a7.6 7.6 0 0 0-1.663-.812L24.97-1.722l1.238 1.237zm-3.014 5.842L-5.059 33.61l1.237 1.237 18.283-18.283zm5.202-2.727a4.7 4.7 0 0 0-.571-1.506 4 4 0 0 0-.159-.239L28.755-.203l1.237 1.237zm-6.131-4.475a17 17 0 0 0-.973-.116 3.67 3.67 0 0 0 1.563-2.949L22.24-4.296l1.237 1.238zM9.664 2.978c.527.274.98.672 1.319 1.156L21.249-6.132 20.01-7.37zm.214-10.821 1.238 1.237-17.234 17.233-1.237-1.237zm20.114 14.58L28.755 5.5-5.06 39.314l1.237 1.237z"
            clip-rule="evenodd"
        />
        <path
            fill="currentColor"
            d="M13.018 11.705c-.8-.855-2.306-1.49-5.018-1.49-2.735 0-4.244.646-5.038 1.512-.213.232-.579.603-.729 1.564a.837.837 0 0 0 .827.96h9.88a.837.837 0 0 0 .827-.96c-.151-.963-.519-1.34-.75-1.586"
        />
    </g>
    <defs>
        <clipPath id="IconBackgroundBlur_16__a">
            <rect
                width="13.333"
                height="13.333"
                x="1.333"
                y="1.75"
                fill="currentColor"
                rx=".833"
            />
        </clipPath>
        <clipPath id="IconBackgroundBlur_16__b">
            <path fill="currentColor" d="M1.333 1.75h13.333v13.333H1.333z" />
        </clipPath>
    </defs>
</svg>
